import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import Logo2 from "./assets/logo2.svg";
import Logo3 from "./assets/logo3.svg";
import LeftEffect from "./assets/left-effect.svg";
import RightEffect from "./assets/right-effect.svg";

export default function CommunitySection() {
    return (
        <section className="relative bg-white py-16 md:py-24 overflow-hidden">
            {/* Left & Right Background Effects */}
            <img
                src={LeftEffect}
                alt="Left effect"
                className="absolute left-0 top-0 h-full object-contain pointer-events-none"
            />
            <img
                src={RightEffect}
                alt="Right effect"
                className="absolute right-0 top-0 h-full object-contain pointer-events-none"
            />

            <div className="relative z-10 flex flex-col items-center text-center px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto">
                {/* Logo with glow effect */}
                <div className="relative flex items-center justify-center w-40 h-40 rounded-full bg-white shadow-lg mb-6">
                    <div className="absolute w-28 h-28 rounded-full bg-gradient-to-r from-gray-200 to-white opacity-50 blur-2xl" />

                    {/* Logo2 (back) */}
                    <img src={Logo2} alt="Logo2" className="w-12 h-12 relative z-10" />

                    {/* Logo3 (front, overlapped) */}
                    <img
                        src={Logo3}
                        alt="Logo3"
                        className="absolute w-20 h-20 z-20"
                    />
                </div>

                {/* Title */}
                <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 mb-6">
                    Ready to Transform Your <br className="hidden md:block" />
                    Workflow?
                </h2>

                {/* Button */}
                <Link
                    to="/signup"
                    className="inline-flex items-center gap-2 bg-black text-white px-7 py-3 rounded-lg text-sm sm:text-base font-medium shadow-md hover:bg-gray-800 transition-colors"
                >
                    Get Started for Free <ArrowRight size={16} />
                </Link>
            </div>
        </section>
    );
}
